import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 53px;
  padding: 0 40px 0 0;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 7px 0 0;
    width: 20%;

    > svg {
      position: absolute;
      left: 25px;
    }
  }

  ${media.lessThan('medium')`
    > button {
      display: none;
    }
  `}
`

export const LinksContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    height: 53px;

    > a {
      text-decoration: none;
      color: ${theme.colors.xgray};
      font-family: ${theme.font.comfortaa};
      font-weight: ${theme.font.xbold};
      font-size: ${theme.font.sizes.normal};
      border-right: 1px solid ${theme.colors.mainBg};
      border-bottom: 1px solid ${theme.colors.mainBg};
      padding: 15px 40px;
      transition: color ${theme.transition.default};

      &:hover {
        color: ${theme.colors.primary};
        border-bottom: 2px solid ${theme.colors.primary};
      }
    }

    .active {
      color: ${theme.colors.primary};
      border-bottom: 2px solid ${theme.colors.primary};
    }
  `}
`
